import { SVGProps } from '@components/Icon/types';

export const Zoom = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.35, 2.35)">
      <path
        d="M4.05 5.14999C4.05 4.54247 4.54249 4.04999 5.15 4.04999H6.15C6.48137 4.04999 6.75 4.31862 6.75 4.64999C6.75 4.98136 6.48137 5.24999 6.15 5.24999H5.25V6.14999C5.25 6.48136 4.98137 6.74999 4.65 6.74999C4.31863 6.74999 4.05 6.48136 4.05 6.14999V5.14999Z"
        fill={fill}
      />
      <path
        d="M10.15 4.04999C10.7575 4.04999 11.25 4.54247 11.25 5.14999V6.14999C11.25 6.48136 10.9814 6.74999 10.65 6.74999C10.3186 6.74999 10.05 6.48136 10.05 6.14999V5.24999H9.15C8.81863 5.24999 8.55 4.98136 8.55 4.64999C8.55 4.31862 8.81863 4.04999 9.15 4.04999H10.15Z"
        fill={fill}
      />
      <path
        d="M4.05 10.15C4.05 10.7575 4.54249 11.25 5.15 11.25H6.15C6.48137 11.25 6.75 10.9814 6.75 10.65C6.75 10.3186 6.48137 10.05 6.15 10.05H5.25V9.15C5.25 8.81863 4.98137 8.55 4.65 8.55C4.31863 8.55 4.05 8.81863 4.05 9.15V10.15Z"
        fill={fill}
      />
      <path
        d="M10.15 11.25C10.7575 11.25 11.25 10.7575 11.25 10.15V9.15C11.25 8.81863 10.9814 8.55 10.65 8.55C10.3186 8.55 10.05 8.81863 10.05 9.15V10.05H9.15C8.81863 10.05 8.55 10.3186 8.55 10.65C8.55 10.9814 8.81863 11.25 9.15 11.25H10.15Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.69907C0 3.46014 3.46014 0 7.69907 0C11.938 0 15.3981 3.46014 15.3981 7.69907C15.3981 9.43555 14.8112 11.0362 13.832 12.3287L13.6479 12.5718L19.0611 17.9862L19.0662 17.9912C19.1392 18.0613 19.1975 18.1452 19.2376 18.238C19.2777 18.3309 19.2989 18.4308 19.3 18.5319C19.301 18.6331 19.2818 18.7334 19.2436 18.8271C19.2054 18.9207 19.1488 19.0058 19.0773 19.0773C19.0058 19.1488 18.9207 19.2054 18.8271 19.2436C18.7334 19.2818 18.6331 19.301 18.5319 19.3C18.4308 19.2989 18.3309 19.2777 18.238 19.2376C18.1452 19.1975 18.0613 19.1392 17.9913 19.0662L12.5718 13.6479L12.3287 13.832C11.0362 14.8112 9.43555 15.3981 7.69907 15.3981C3.46014 15.3981 0 11.938 0 7.69907ZM7.69907 1.52043C4.27355 1.52043 1.52043 4.27355 1.52043 7.69907C1.52043 11.1246 4.27355 13.8777 7.69907 13.8777C9.34498 13.8777 10.8323 13.2374 11.9365 12.1974L11.9606 12.1747L11.98 12.1479C12.0273 12.0825 12.0847 12.0251 12.15 11.9778L12.1769 11.9584L12.1997 11.9342C13.2383 10.8302 13.8777 9.34379 13.8777 7.69907C13.8777 4.27355 11.1246 1.52043 7.69907 1.52043Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'zoom';
